import { render, staticRenderFns } from "./Alertresource.vue?vue&type=template&id=a9b04a10&scoped=true"
import script from "./Alertresource.vue?vue&type=script&lang=js"
export * from "./Alertresource.vue?vue&type=script&lang=js"
import style0 from "./Alertresource.vue?vue&type=style&index=0&id=a9b04a10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b04a10",
  null
  
)

export default component.exports